/**
=========================================================
* Material Dashboard 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState } from "react";
// import { useNavigate } from "react-router";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
// import MenuItem from "@mui/material/MenuItem";
// import Select from "@mui/material/Select";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import useAuthorizedRequest from "components/AuthorizedRequest";
import { Alert, Snackbar } from "@mui/material";

function SupplierAdd() {
  const authorizedReq = useAuthorizedRequest();
  // const navigate = useNavigate();

  // const [status, setStatus] = useState(1);
  // const [supplierName, setSupplierName] = useState("");
  const [snackProps, setSnackProps] = useState({
    message: "",
    severity: "info",
    isOpen: false,
  });
  const [supplierData, setSupplierData] = useState({
    supplier_name: "",
    status: "active",
  });

  // const handleStatusChange = (event) => {
  //   setStatus(event.target.value);
  // };

  const handleSnackClose = () => {
    setSnackProps({ ...snackProps, isOpen: false });
  };

  const handleAddSupplier = () => {
    authorizedReq
      .post(`${process.env.REACT_APP_API_BASE_URL}/supplier`, supplierData, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      })
      .then(() => {
        setSnackProps({
          isOpen: true,
          message: "Supplier Saved!",
          severity: "success",
        });
        setSupplierData({
          supplier_name: "",
        });
      })
      .catch((err) => {
        setSnackProps({
          isOpen: true,
          message: err.message,
          severity: "error",
        });
      });
  };

  // console.log(supplierData);

  return (
    <DashboardLayout>
      <div>
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          open={snackProps.isOpen}
          onClose={handleSnackClose}
          autoHideDuration={6000}
        >
          <Alert onClose={handleSnackClose} severity={snackProps.severity} sx={{ width: "100%" }}>
            {snackProps.message}
          </Alert>
        </Snackbar>
      </div>
      <DashboardNavbar />
      <MDBox mt={6} mb={3}>
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} lg={12}>
            <Card>
              <MDBox pt={4} pb={3} px={3}>
                <MDBox
                  component="form"
                  role="form"
                  onSubmit={(e) => {
                    e.preventDefault();
                    handleAddSupplier();
                  }}
                >
                  <MDBox mb={2}>
                    <MDTypography variant="text">Supplier Name</MDTypography>
                    <MDInput
                      type="input"
                      fullWidth
                      placeholder="Supplier Name"
                      value={supplierData.supplier_name}
                      onChange={(e) =>
                        setSupplierData({
                          supplier_name: e.target.value,
                          // status: supplierData.status,
                        })
                      }
                    />
                  </MDBox>
                  {/* <MDBox mb={2}>
                    <MDTypography variant="text">Status</MDTypography>
                    <Select
                      labelId="status"
                      id="status"
                      value={supplierData.status}
                      label="status"
                      variant="standard"
                      defaultValue=""
                      onChange={(e) =>
                        setSupplierData({
                          supplier_name: supplierData.supplier_name,
                          status: e.target.value,
                        })
                      }
                      fullWidth
                    >
                      <MenuItem value={1}>Active</MenuItem>
                      <MenuItem value={0}>Inactive</MenuItem>
                    </Select>
                  </MDBox> */}
                  <MDBox mt={4} mb={1}>
                    <MDButton
                      variant="gradient"
                      color="success"
                      fullWidth
                      onClick={handleAddSupplier}
                    >
                      Save
                    </MDButton>
                  </MDBox>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default SupplierAdd;
